<template>
    <div>
        <div class="w-100">
            <div class="float-left">
            <h6><strong>{{ this.$t('Entities.UserAccount.UserRoles') }}:</strong> {{ availability ? availability.userRolesDisplayNames : null }}</h6>
            </div>
        </div>

        <div v-if="availability">
            <h6 class="float-right"><strong>{{ this.$t('Entities.UserProfile.Timezone') }}:</strong> {{ availability ? availability.userTimeZoneDisplayName : null }}</h6>
            <b-table-simple fixed class="table table-bordered">
                <b-thead>
                    <b-tr>
                        <b-th></b-th>
                        <b-th style="font-size: 20px;" v-for="day in weekDayArray" :key="day" :variant="getVariantColor(day)" class="align-middle text-center">{{ day }}</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td class="align-middle text-center" style="font-size: 45px;"><div class="h-100">AM</div><hr /><div class="h-50">PM</div></b-td>
                        <b-td v-for="(day,index) in availability.days" :key="index" class="align-middle text-center" style="padding:5px;">

                            <div v-for="(slot,index) in day.timeSlots" :key="day + index" class="ml-3" style="">
                                <b-form-checkbox @change="updateDataChangedStatus()" size="sm" style="padding: 0 4px 0 27px; border: 1px solid #AAA;" class="float-left" v-model="slot.selected" v-bind:class="getTimeSlotBackground(slot.timeSlotValue)" v-if="showAfterHoursTimeSlots || (slot.timeSlotValue >= 800 && slot.timeSlotValue < 1800)">
                                    {{ slot.timeSlotStartDisplayText }}
                                </b-form-checkbox>
                            </div>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>

        <div class="w-100">
            <b-button size="sm" @click="toggleCheckboxes" class="float-right" variant="warning">{{ toggleButtonLabel }}</b-button>
            <div class="float-left">
                <b-checkbox size="sm" button-variant="success" @change="toggleAfterHoursVisibility()" switch>Show before / after business hours</b-checkbox>
                <b-badge class="p-2" pill variant="danger" v-if="availability && checkIfHiddenTimeSlotsExist && !showAfterHoursTimeSlots">Hidden time slots</b-badge>
            </div>
        </div>

        <div class="mt-4 float-left" v-if="availability && (availability.showAudioMinutes || availability.showTravel || availability.showOnSite || availability.showRealTime)">
            <h5>Availability Options</h5>
            <b-table-simple hover fixed class="table table-bordered">
                <b-thead>
                    <b-tr>
                        <b-th></b-th>
                        <b-th style="font-size: 20px;" v-for="day in weekDayArray" :key="day" :variant="getVariantColor(day)" class="align-middle text-center">{{ day }}</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-if="availability.showAudioMinutes">
                        <b-td>Delayed (audio mins)</b-td>
                        <b-td v-for="(day,index) in availability.days" :key="index" class="text-center">
                            <center>
                                <b-form-input @change="updateDataChangedStatus()" v-model="day.audioMinutes" size="sm" placeholder="mins" class="w-50 text-right" />
                            </center>
                        </b-td>
                    </b-tr>
                    <b-tr v-if="availability.showTravel">
                        <b-td>Travel</b-td>
                        <b-td v-for="(day,index) in availability.days" :key="index" class="text-center">
                            <b-form-checkbox @change="updateDataChangedStatus()" v-model="day.availableForTravel" :disabled="disableEnableFormInputs(day)" />
                        </b-td>
                    </b-tr>
                    <b-tr v-if="availability.showOnSite">
                        <b-td>On site</b-td>
                        <b-td v-for="(day,index) in availability.days" :key="index" class="text-center">
                            <b-form-checkbox @change="updateDataChangedStatus()" v-model="day.availableForOnSite" :disabled="disableEnableFormInputs(day)" />
                        </b-td>
                    </b-tr>
                    <b-tr v-if="availability.showRealTime">
                        <b-td>Real time</b-td>
                        <b-td v-for="(day,index) in availability.days" :key="index" class="text-center">
                            <b-form-checkbox @change="updateDataChangedStatus()" v-model="day.availableForRealTime" :disabled="disableEnableFormInputs(day)" />
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>

        <div style="margin-right: 50px; float: right;">
            <b-row class="m-30">
                <b-button @click="saveAvailability" :disabled="httpSaveInProgress" :variant="dataChanged ? 'success' : 'secondary'">SAVE</b-button>
            </b-row>
        </div>

        <div class="d-flex justify-content-center">
            <b-spinner variant="secondary" label="Loading..." v-if="showSpinner"></b-spinner>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { BootstrapVue } from 'bootstrap-vue'
    import axios from 'axios';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import UuidMixins from '../../mixins/UuidMixins';
    Vue.use(BootstrapVue)

    export default {
        name: 'AvailabilityTemplate',
        mixins: [ErrorsMixin, UuidMixins],
        props: {
            apiControllerUrl: {
                type: String,
                required: true
            },
            label: {
                type: String,
                default: 'Availability Template'
            }
        },

        data: function () {
            return {
                availability: null,
                checkboxesDisabled: false,
                showSpinner: false,
                checkBoxToggleState: true,
                showAfterHoursTimeSlots: false,
                fixed: true,
                weekDayArray: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
                dataChanged: false,
                httpSaveInProgress: false
            }
        },

        computed: {
            checkIfHiddenTimeSlotsExist: function () {
                for (var j = 0; j < 7; j++) {
                    for (var i = 0; i < 48; i++) {
                        if (i < 16 || i > 35) {
                            if (this.availability.days[j].timeSlots[i].selected) return true;
                        }
                    }
                }
                return false;
            },
            toggleButtonLabel: function () {
                if (this.checkBoxToggleState) { return 'Select business hours'; }
                else { return 'Deselect business hours'; }
            }
        },
            
        methods: {
            updateDataChangedStatus: function() {
                this.dataChanged = true;
            },
            getTimeSlotBackground(slot) {
                if ((slot >= this.$config.businessHoursStartTime) && (slot < this.$config.businessHoursEndTime)) return 'businessHourBackGround active'
            },
            disableEnableFormInputs: function (day) {
                var found = false;
                for (var i = 0; i < day.timeSlots.length; i++) {
                    if (day.timeSlots[i].selected) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    day.availableForTravel = false;
                    day.availableForOnSite = false;
                    day.availableForRealTime = false;
                }
                return !found;
            },
            loadAvailability: function () {
                this.showSpinner = true;
                axios
                    .get(this.apiControllerUrl)
                    .then(response => {
                        this.availability = response.data;
                        this.showSpinner = false;
                    })
                    .catch(ex => {
                        this.showSpinner = false;
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },
            saveAvailability: function () {

                this.httpSaveInProgress = true;
                this.dataChanged = false;
                this.showSpinner = true;
                for (var i = 0; i < 7; i++) {
                    var audioMinutesInput = this.availability.days[i].audioMinutes;
                    // digits only                    
                    var regEx = /^\d+$/;

                    // have to check audioMinutesInput for null and for '' because it changes value during use
                    // initially it is null and shows the placeholder 'mins' once edited it shows the placeholder 'mins' and a value of ''
                    if ((audioMinutesInput !== null && audioMinutesInput != '' && !regEx.test(audioMinutesInput)) ||
                        ((audioMinutesInput > 1440) ||
                            (audioMinutesInput < 0))) {
                        this.showSpinner = false;
                        this.$bvToast.toast('Valid range: [0..1440] minuntes', {
                            title: 'Delayed audio minutes out of range',
                            variant: 'warning',
                            appendToast: true
                        });
                        return;
                    }
                }  
                axios
                    .post(this.apiControllerUrl, JSON.stringify(this.availability),
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.$bvToast.toast('Availability Template saved successfully', {
                            title: 'Availability Template',
                            variant: 'success',
                            appendToast: true
                        });
                        this.showSpinner = false;
                        this.httpSaveInProgress = false;
                    })
                    .catch(ex => {
                       
                        this.showSpinner = false;
                        this.httpSaveInProgress = false;
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },
            getWeekday(index) {
                return this.weekDayArray[index]
            },
            getVariantColor: function (day) {
                if (day == 'SAT' || day == 'SUN') return 'danger'
                else return 'light'
            },
            toggleCheckboxes: function () {
                
                for (var j = 0; j < 5; j++) { 

                    for (var i = 0; i < 48; i++) {
                        this.availability.days[j].timeSlots[i].selected = false;
                        if (this.availability.days[j].timeSlots[i].timeSlotValue >= 800 && this.availability.days[j].timeSlots[i].timeSlotValue < 1800)
                            this.availability.days[j].timeSlots[i].selected = this.checkBoxToggleState;
                    }
                }
                this.checkBoxToggleState = !this.checkBoxToggleState;
                this.dataChanged = true;
            },
            toggleAfterHoursVisibility: function () {
                this.showAfterHoursTimeSlots = !this.showAfterHoursTimeSlots;
            },
        }, // methods

        mounted: function () {
            this.loadAvailability();
            let _this = this
            window.addEventListener('beforeunload', function (e) {
                if (_this.dataChanged) {
                    // If you prevent default behavior in Mozilla Firefox prompt will always be shown
                    e.preventDefault(); 
                    // Chrome requires returnValue to be set
                    e.returnValue = '';
                }
            });
        },
    }
</script>

<style scoped>
    .businessHourBackGround {
        background-color: #ddd;
    }
</style>
